import { BucketingStrategy } from './bucketing-strategy';
import { BucketDef } from './bucket-def';
import * as moment from 'moment';
import { frequencyFromAlias, getNextDateByFrequency, Frequency } from '@liquitics/transaction';

export abstract class BaseBucketingStrategy {

    protected today: moment.Moment;
    protected bucketDefs: BucketDef[] = [];

    constructor(todayStr: string, expandFirstBucket?: boolean) {
        this.today = moment.utc(todayStr);
        this.initBucketDefs();
        // this.bucketDefs.forEach(bd => {
        //     console.log(bd.bucketName + ":" + bd.bucketStartDate.format("MM-DD") + "-" + bd.bucketEndDate.format("MM-DD"));
        // })
        // Initialize with the first bucket expanded (if expandable)
        if (expandFirstBucket && this.bucketDefs.length > 0) {
            if (this.bucketDefs[0].expandable) {
                this.bucketDefs[0].expand();
            }
        }
    }

    abstract initBucketDefs(): void;

    getToday(): moment.Moment {
        return this.today;
    }

    handleBucketSelection(selected: string): void {
        this.bucketDefs
            .forEach(bd => {
                if (bd.bucketName === selected) {
                    bd.expand();
                } else {
                    bd.collapse();
                }
            });
    }

    getBucket(dateStr: string): BucketDef {
        const dateM = moment.utc(dateStr);
        const foundBucket = this.bucketDefs
            .find(bd => {
                return (bd.contains(dateM));
            });
        return foundBucket;
    }

    getBucketName(dateStr: string): string {
        const bucket = this.getBucket(dateStr);
        if (bucket) {
            return bucket.getBucketNameFromString(dateStr);
        }
        return undefined;
    }

    moment(dateString: string): moment.Moment {
        return moment.utc(dateString).startOf('day');
    }

    addMonths(moment: moment.Moment, numMonths: number, useAnchoringLogic: boolean) {
        let date = moment.clone().add(numMonths, 'months');
        if (useAnchoringLogic && moment.date() === moment.daysInMonth()) {
            date = date.endOf('month').startOf('day');
        }
        return date;
    }

    protected lastBucketDate(): moment.Moment {
        if (this.bucketDefs.length === 0) {
            return undefined;
        }
        return this.bucketDefs[this.bucketDefs.length - 1].bucketEndDate;
    }

    protected startOfNextBucket(): moment.Moment {
        const lastDate = this.lastBucketDate();
        if (!lastDate) {
            return undefined;
        }
        return lastDate.clone().add(1, 'days');
    }

    getAllBucketTenors(): string[] {
        return this.bucketDefs
            .map((bd: BucketDef) => {
                return bd.bucketName;
            });
    }

    getBucketNameFromTenor(tenor: string): string {
        const prefix = parseInt(tenor.slice(0, -1), 10);
        const suffix = tenor.slice(-1);
        if (suffix === 'D' || suffix === 'M' || suffix === 'Y') {
            const frequency: Frequency = frequencyFromAlias(suffix);
            let bucket = this.getBucketName(getNextDateByFrequency(this.getToday().format('YYYY-MM-DD'), frequency, prefix, 'NONE'));
            if (!bucket) {
                if (prefix < 0) {
                    bucket = this.bucketDefs[0].bucketName;
                }
            }
            return bucket;
        } else {
            return tenor;
        }
    }
}
